<template>
  <div class="dashboard-card">
    <div class="dashboard-card__title">Actividad reciente</div>

    <div v-if="!activities.length" class="dashboard-empty">
      No hay actividad reciente
    </div>

    <div v-else class="activity-list">
      <div v-for="(item, index) in activities" :key="index" class="activity-item">
        <div class="activity-item__icon" :class="`activity-item__icon--${item.color}`">
          <CIcon :name="item.icon" />
        </div>
        <div class="activity-item__content">
          <div class="activity-item__description">{{ item.description }}</div>
          <div class="activity-item__date">{{ item.dateText || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import recentActivityService from '@/services/dashboard/recent_activity_dashboard'

export default {
  name: 'RecentActivityCard',
  props: {
    eventId: { type: [String, Number], required: true },
    refreshToken: { type: Number, default: 0 }
  },
  data() {
    return {
      activities: []
    }
  },
  watch: {
    eventId: {
      immediate: true,
      handler() {
        this.loadActivity()
      }
    },
    refreshToken() {
      this.loadActivity()
    }
  },
  methods: {
    async loadActivity() {
      this.activities = await recentActivityService.get(this.eventId)
    }
  }
}
</script>

<style scoped>
.dashboard-card {
  height: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #dfe7df;
  background: #fff;
  box-shadow: 0 4px 14px rgba(31, 41, 55, 0.08);
}

.dashboard-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 12px;
}

.dashboard-empty {
  font-size: 13px;
  color: #6b7280;
  padding: 16px 0;
}

.activity-list {
  max-height: 340px;
  overflow-y: auto;
  padding-right: 2px;
}

.activity-item {
  display: flex;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #edf1ed;
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-item__icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.activity-item__icon--success {
  background: #4a8f5e;
}

.activity-item__icon--danger {
  background: #b85b5b;
}

.activity-item__icon--warning {
  background: #c4a948;
}

.activity-item__description {
  font-size: 13px;
  color: #374151;
}

.activity-item__date {
  margin-top: 3px;
  font-size: 11px;
  color: #6b7280;
}
</style>
